export var SERVER_NAME = "New Alldernow";
export var LOGO_URL = "/images/logo.png";
